export const OUTER_EYE_SIZE_IN_BITS = 7;
export const INNER_EYE_SIZE_IN_BITS = 3;

export const EYES_POSITIONS = ['topLeft', 'topRight', 'bottomLeft'];

// QR code error collection percentages
export const QR_ECL_PERS = {
  L: 0.03,
  M: 0.06,
  Q: 0.1,
  H: 0.14,
  low: 0.03,
  medium: 0.06,
  quartile: 0.1,
  high: 0.14,
};
